import { useExternalScriptsStore } from "../store/useUserInfo";
export const useScriptIsEnabled = (scriptName) => {
    return useExternalScriptsStore((s) => s.userInfo?.results.services.find((s) => s.key === scriptName)?.isEnabled);
};
